import React from 'react';
import { PageHeader } from "../../../components";

export default function OTHERGAME() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_CHAIRMAN_OTHER_GAMES.jpg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">Mr. TUNJI AKINWANDE</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                 Tunji Akinwande is currently a Director at Peers Consulting. He oversees the Finance department of Peers Consulting in addition to his Consulting job. Prior to forming Peers with other professionals from Deloitte & Touche Consulting, West Africa (DTC), Tunji was a Principal Consultant at DTC. He is a key member of the Information Technology (IT) Services Unit. Tunji has performed several systems related projects including Systems Development, Systems Implementation and Project Management on mid-range  computers  systems. He is an expert in Enterprise Resource Solution Delivery. He has implemented Oracle JD Edwards Enterprise Solution (ERP software) and Oracle EnterpriseOne Solution consisting of business modules such as General Accounting, Accounts Receivable, Accounts Payable, Fixed Asset Management, Inventory Management, Purchase Order Management, Sales Order Management, Warehouse Management and Equipment Maintenance for a lot of clients. Some of his clients include : Mobil Equatorial Guinea Incorporation, Mobil Producing Nigeria Unlimited, Mobil Oil Nigeria PLC (now called 11 PLC), Chevron Nigeria Limited, Cabinda Gulf Oil Company (Chevron) Angola, Texaco Nigeria PLC (Now called MRS Oil PLC), Texaco Cameroun, Shell Ghana, Conoil (Nigeria) Plc, First City Monument Bank (FCMB), Ashanti Goldfields Company (AGC) Ghana Limited, Tema Oil Refinery (Ghana), Stahe House Abuja and  GlaxoSmithkline Consumer Nigeria PLC’. Tunji is also the Chairman of Dwise Travels and Tours Limited, and Ahakol Investments Limited.

Tunji holds a B.Sc. degree in Computer Science from University of Ibadan and a Master of Business Administration (MBA) degree from University of Lagos. He attended several accounting, management, and consulting training  courses locally and abroad. He is a member of the Nigeria Computer Society, Computer Professionals of Nigeria (CPN) and Nigeria Institute of Management (NIM). He is also a member of Lagos Country Club and has served at the club’s Commitee level (Membership Screening; Electoral; Security and Facility Management) as well as at Sectional Level (Other Games – Committee member, Secretary, Vice Chairman).
Tunji is married with Children. 
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
